import { useEffect, useRef } from 'react';

import { analytics } from '../utilities/analytics';
import { DenialReason } from '../utilities/analytics.types';

interface DenialTrackingOptions {
  denied: boolean;
  reason: DenialReason;
  itemCategory: string;
  itemId?: string;
  itemName?: string;
  startDate?: string;
  endDate?: string;
}

export function useDenialTracking({
  denied,
  reason,
  itemCategory,
  itemId,
  itemName,
  startDate = '',
  endDate = '',
}: DenialTrackingOptions): void {
  const hasFired = useRef(false);

  useEffect(() => {
    if (!denied) {
      hasFired.current = false;
      return;
    }

    if (hasFired.current) {
      return;
    }

    analytics.track({
      event: 'denial',
      params: {
        start_date: startDate,
        end_date: endDate,
        reason,
        items: [{ item_category: itemCategory, item_id: itemId, item_name: itemName }],
      },
    });

    hasFired.current = true;
  }, [denied, reason, itemCategory, itemId, itemName, startDate, endDate]);
}
